export enum LocalStorageKeys {
  TOKEN = 'user:token',
}
